import { useQuery } from '@tanstack/react-query';
import { documentApiConnect } from '../lib/api/documentApi.connect';
import { useFlagsReady } from '../lib/connect';
export function useDocuments(options = {}) {
    const { limit = 50, offset = 0, status, sortBy = 'recent', autoRefresh = false, refreshInterval = 5000 } = options;
    const flagsReady = useFlagsReady();
    const params = {
        limit,
        offset,
        status,
        sortBy
    };
    const query = useQuery({
        queryKey: [
            'standaloneDocuments',
            limit,
            offset,
            status,
            sortBy
        ],
        queryFn: ()=>documentApiConnect.listDocuments(params),
        enabled: flagsReady,
        staleTime: 5000,
        refetchInterval: autoRefresh ? refreshInterval : false
    });
    return {
        documents: query.data?.documents ?? [],
        loading: query.isLoading,
        error: query.error instanceof Error ? query.error.message : null,
        total: query.data?.pagination.total ?? 0,
        hasMore: query.data?.pagination.hasMore ?? false,
        refetch: async ()=>{
            await query.refetch();
        }
    };
}
